@if (showComponent()) {
    <div class="container-fluid well">
        <h5>{{title}}</h5>
        @if (showResubdivisionCompliesWithSchedule()) {
            <div class="row">
                <div class="col-xs-12">
                    <div class="checkbox mg0">
                        <div
                            class="checkbox-inline"
                            title="Select if this is a staged re-subdivision that complies with the by-laws of the management statement">
                            <i
                                class="nlrp-icon"
                                [ngClass]="{'active': getStrata().resubdivisionCompliesWithSchedule, 'nlrp-icon-check-box-selected': getStrata().resubdivisionCompliesWithSchedule, 'nlrp-icon-check-box-unselected': !getStrata().resubdivisionCompliesWithSchedule}"
                                (click)="resubdivisionCompliesWithScheduleHandler()">
                            </i>
                            <span
                                >This plan complies with, or is only a minor variation of, staged by-law(s) registered in respect of the scheme as
                                determined by the applicable regulations.</span
                            >
                            <input
                                type="checkbox"
                                name="resubdivisionCompliesWithSchedule"
                                id="resubdivisionCompliesWithSchedule"
                                style="visibility: hidden;"
                                [(ngModel)]="getStrata().resubdivisionCompliesWithSchedule"
                                [ngClass]="{active: getStrata().resubdivisionCompliesWithSchedule}"
                                [disabled]="isResubdivisionCompliesWithScheduleDisabled()" />
                        </div>
                    </div>
                </div>
            </div>
        }
        @if (showBylawReferences()) {
            <div class="row">
                <div class="col-xs-6">
                    <label
                        class="control-label"
                        for="bylawReferences">
                        By-law Reference(s)
                    </label>
                    <div
                        class="input-group"
                        [ngClass]="{'has-error': bylawReferences | formFieldHasError}">
                        <span class="input-group-addon corner">
                            <i class="nlrp-icon nlrp-icon-edit corner-icon"></i>
                        </span>
                        <textarea
                            class="form-control"
                            name="bylawReferences"
                            id="bylawReferences"
                            placeholder="Enter the By-law Reference(s)"
                            rows="4"
                            cols="60"
                            maxlength="255"
                            title="Enter the By-law Reference(s)"
                            [disabled]="isBylawReferencesDisabled()"
                            [(ngModel)]="getStrata().bylawReferences"
                            #bylawReferences="ngModel">
                        </textarea>
                    </div>
                </div>
            </div>
        }
    </div>
}
